<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
            <div class="page-title-box">
            <div class="float-right">
                <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Wajib Retribusi</li>
                <li class="breadcrumb-item active">{{ $route.name == 'instanceCustomerCreate' ? 'Tambah' : 'Edit' }}</li>
                </ol>
            </div>
            
            <h4 class="page-title">
                <router-link :to="{ name: 'instanceCustomer' }" :disabled="loading">
                    <i class="fas fa-arrow-left mr-2"></i>
                </router-link>
                Wajib Retribusi
            </h4>
            </div>
        </div>
    </div>

    <div class="card card-loader d-flex" v-if="loadingInitial">
         <div class="justify-content-center">
             <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                 <span class="sr-only">Loading...</span>
             </div>
             <p class="mt-2">Loading</p>
         </div>
     </div>

    <div v-else>
        <form @submit.prevent="submitForm()">
             <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-6" v-if="masterDataPrefix">
                            <div class="form-group">
                                <label for="select-2-form" class="col-form-label text-left d-block">{{masterDataPrefix.name}}</label>
                                <select class="form-control" id="exampleFormControlSelect1" v-model="dataCustomer.master_data_item_id" :disabled="loading"
                                    @change="checkCustomerCode('SELECT')">
                                    <option value="">-- Pilih {{masterDataPrefix.name}} --</option>
                                    <option :value="item.id" v-for="item in masterDataPrefix.items" :key="item.id">
                                        {{item.value}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12" :class="setClass">
                            <div class="form-group" :class="{ 'is-invalid': !codeCustomerCheck }">
                                <label for="select-2-form" class="col-form-label text-left d-block">Kode Wajib Retribusi</label>
                                 <!-- || $route.name == 'instanceCustomerEdit' -->
                                <div style="position: relative">
                                    <input type="text" class="form-control" 
                                    @keyup="checkCustomerCode('TYPING')"
                                    v-model="dataCustomer.customer_code" placeholder="Masukkan Kode Retribusi"
                                    :disabled="loading || $route.name == 'instanceCustomerEdit'">
                                    <div class="spinner-border spinner-grow-sm" role="status"
                                        v-if="loadingCustomerChecker"
                                        style="position: absolute; top: 10px; right: 10px">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                                <div class="error" v-if="!codeCustomerCheck">Kode wajib retribusi sudah pernah digunakan</div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="select-2-form" class="col-form-label text-left d-block">Nama</label>
                        <input type="text" class="form-control" placeholder="Masukkan Nama" v-model="dataCustomer.name" :disabled="loading" required>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6" v-for="(item, index) in customFields" :key="item.id">
                            <div class="form-group" >
                                <label class="form-label text-left d-block">{{item.label}}</label>
                                <input class="form-control" :type="item.type" v-model="customFields[index].field_value" 
                                :placeholder="`Masukkan ${item.label}`" :disabled="loading"
                                v-if="item.type == 'TEXT' || item.type == 'NUMBER'">

                                <select
                                v-if="item.type == 'SELECT' && item.masterData"
                                class="form-control" id="exampleFormControlSelect1" v-model="customFields[index].field_value" :disabled="loading">
                                    <option value="TEXT">-- Pilih {{item.label}} --</option>
                                    <option :value="itemSelect.id" v-for="itemSelect in item.masterData.items" :key="itemSelect.id">
                                        {{itemSelect.value}}
                                    </option>
                                </select>

                                <div v-if="item.type == 'DATE'"
                                    style="padding-top: 10px;">
                                    <!-- <VueDatePicker
                                        :placeholder="`Masukkan ${item.label}`"
                                        format="DD/MM/YYYY"
                                        v-model="customFields[index].field_value" 
                                    /> -->
                                    <date-picker style="width: 100%" v-model="customFields[index].field_value" valueType="format" :placeholder="'Masukkan ' + item.label" format="DD/MM/YYYY"></date-picker>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button class="btn btn-success waves-effect waves-light mb-5" :disabled="loading">
                Simpan Wajib Retribusi
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>
        </form>
    </div>
    
  </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    export default {
        data() {
            return {
                loading: false,
                loadingInitial: true,
                loadingCustomerChecker: false,

                codeCustomerCheck: true,
                dataCustomer: {
                    customer_code: '',
                    master_data_item_id: '',
                    name: '',
                },
                customFields: [],
                masterDataPrefix: null,
                prefixCustomFieldID: null,
            }
        },
        computed: {
            setClass(){
                return this.masterDataPrefix ? 'col-md-6' : 'col-md-12'
            }
        },
        components: {
            // VueDatePicker,
            DatePicker
        },
        methods: {
            allowedDates(date) {
                return ALLOWED_DAYS.includes(activeDay);
                const activeDay = DAYS[date.getDay()];
            },
            setDefaultDate(index) {
                this.customFields[index].field_value = new Date()
            },
            async checkCustomerCode(type) {
                this.loadingCustomerChecker = true
                
                if(type == 'TYPING'){
                    try {
                        const generateCode = await this.$http.get(`${this.API_URL}customer/validate-code?customer_code=${this.dataCustomer.customer_code}`, {
                            headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                        })
                        
                        this.loadingCustomerChecker = false
                        this.codeCustomerCheck = true
                    } catch (error) {
                        console.log(error);
                        this.loadingCustomerChecker = false
                        this.codeCustomerCheck = false
                    }
                }else{
                    try {
                        this.codeCustomerCheck = true

                        const generateCode = await this.$http.get(`${this.API_URL}customer/generate-code`, {
                            params: {
                                area_master_data_item_id: this.dataCustomer.master_data_item_id
                            },
                            headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                        })
                        
                        this.dataCustomer.customer_code = generateCode.data.data.code

                        this.loadingCustomerChecker = false
                    } catch (error) {
                        this.loadingCustomerChecker = false
                    }
                }
            },
            showDetail(companySetting) {
                return this.$http.get(`${this.API_URL}customer/${this.$route.params.id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                .then(response => {
                    const result = response.data;

                    this.dataCustomer.name = result.data.name
                    this.dataCustomer.customer_code = result.data.customer_code
                    this.dataCustomer.master_data_item_id = result.data.master_data_item_id

                    let filterData
                    if(companySetting.data.data.area_master_data_id){
                        filterData = result.data.fields.filter(item => {
                            if(item.master_data){
                                this.prefixCustomFieldID = {
                                    id: item.id,
                                    custom_field_id: item.custom_field_id
                                }
                                return item.master_data.id != companySetting.data.data.area_master_data_id
                            }else{
                                return item
                            }
                        })
                    }else{
                        filterData = result.data.fields
                    }

                    this.customFields = filterData.map(item => {
                        return {
                            id_per_value: item.id,
                            id: item.custom_field_id,
                            type: item.field_type,
                            label: item.label,
                            field_value: item.field_value,
                            masterData: item.master_data
                        }
                    })

                    // this.customFields = result.data.fields.map(item => {
                    //     return {
                    //         id_per_value: item.id,
                    //         id: item.custom_field_id,
                    //         type: item.field_type,
                    //         label: item.label,
                    //         field_value: item.field_value,
                    //         masterData: item.master_data
                    //     }
                    // })

                    this.loadingInitial = false
                }).catch(err => {
                    this.loadingInitial = false
                    console.log(err);
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                })
            },
            async loadInitialData() {
                try{
                    const companySetting = await this.$http.get(`${this.API_URL}company-setting`, {
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                    })

                    if(companySetting.data.data.area_master_data_id){
                        const masterData = await this.$http.get(`${this.API_URL}master-data/${companySetting.data.data.area_master_data_id}`, {
                            headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                        })

                        this.masterDataPrefix = masterData.data.data

                    }else{
                        const customerCode = await this.$http.get(`${this.API_URL}customer/generate-code`, {
                            params: {
                                area_master_data_item_id: null
                            },
                            headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                        })

                        this.dataCustomer.customer_code = customerCode.data.data.code
                    }

                    if(companySetting.data.data.customer_form_id){
                        const formTemplate = await this.$http.get(`${this.API_URL}form-template/${companySetting.data.data.customer_form_id}`, {
                            headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                        })

                        const resultForm = formTemplate.data;
                        if (companySetting.data.success && resultForm.success) {
                            if(this.$route.name == 'instanceCustomerCreate') {
                                let filterData
                                if(companySetting.data.data.area_master_data_id){
                                    filterData = await resultForm.data.custom_fields.filter(item => {
                                        if(item.master_data){
                                            this.prefixCustomFieldID = item.id
                                            return item.master_data.id != companySetting.data.data.area_master_data_id
                                        }else{
                                            return item
                                        }
                                    })
                                }else{
                                    filterData = resultForm.data.custom_fields
                                }

                                this.customFields = filterData.map(item => {
                                    return {
                                        id: item.id,
                                        type: item.field_type,
                                        label: item.label,
                                        field_value: null,
                                        masterData: item.master_data
                                    }
                                })

                                this.loadingInitial = false
                            }else{
                                // FOR EDIT
                                console.log('filter2');
                                this.showDetail(companySetting)
                            }
                        }else{
                            this.sAlert('error', resultForm.message)
                        }
                    }else {
                        if(this.$route.name == 'instanceCustomerEdit'){
                            this.showDetail(companySetting)
                        }
                        this.loadingInitial = false
                    }
                } catch (error) {
                    console.log(error);
                    this.loadingInitial = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                }
            },
            submitForm(type) {
                this.loading = true

                let url, method, alertSuccess, storedData

                if(!this.codeCustomerCheck) {
                    this.sAlert('error', 'Harap isi semua form dengan benar!')
                    this.loading = false
                    return
                }

                if(this.masterDataPrefix){
                    if(this.$route.name == 'instanceCustomerEdit'){
                        this.customFields.push({
                            id: this.prefixCustomFieldID.custom_field_id,
                            field_value: this.dataCustomer.master_data_item_id,
                            id_per_value: this.prefixCustomFieldID.id
                        })
                    }else{
                        this.customFields.push({
                            id: this.prefixCustomFieldID,
                            field_value: this.dataCustomer.master_data_item_id,
                            id_per_value: null 
                        })
                    }
                }
                
                if(this.$route.name == 'instanceCustomerCreate') {
                    url = `customer/store`
                    method = 'POST'
                    alertSuccess = 'Berhasil membuat wajib retribusi baru!'
                    storedData = {
                        ...this.dataCustomer,
                        fields: this.customFields.map(item => {
                            return {
                                custom_field_id: item.id,
                                field_value: item.field_value
                            }
                        })
                    }
                }else {
                    url = `customer/update/${this.$route.params.id}`
                    method = 'PUT'
                    alertSuccess = 'Berhasil mengupdate wajib retribusi form!'
                    storedData = {
                        ...this.dataCustomer,
                        fields: this.customFields.map(item => {
                            return {
                                id: item.id_per_value,
                                custom_field_id: item.id,
                                field_value: item.field_value
                            }
                        })
                    }
                }

                this.$http({
                    method,
                    url: `${this.API_URL}${url}`,
                    data: storedData,
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                .then(response => {
                    const result = response.data;
                    
                    if(result.success) {
                        this.sAlert('success', alertSuccess)
                        this.$router.push({ name: 'instanceCustomer' });
                    }else {
                        this.sAlert('error', result.message)
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.sAlert('error', error.response.data.message)
                });
            }
        },
        mounted() {
            this.loadInitialData()
        }
    }
</script>